import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CircleArrowUp.svg",
  "use": "CircleArrowUp.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CircleArrowUp.svg\"><path d=\"M8,32A24,24,0,1,1,32,56,24,24,0,0,1,8,32Zm44,0A20,20,0,1,0,30,51.8989V26.8281l-7.573,7.5871a2.0016,2.0016,0,0,1-2.8289-2.8324L30.6026,20.56a1.998,1.998,0,0,1,2.8288,0L44.4361,31.5828a2.0017,2.0017,0,0,1-2.8293,2.8324L34,26.7941V51.8989A20.0007,20.0007,0,0,0,52,32Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol